import { BRANCH } from "../../actions";

const branchNameReducer = (state = null, action) => {
    switch (action.type) {
        case BRANCH.BRANCHNAME:
            return action.name;
        default:
            return state;
    }
}

export default branchNameReducer;